import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { paymentClient } from '../../api'
import { clearCheckoutState, storedCheckoutSessionId, storedReturnPath } from './paymentFlow'
import { PaymentPage } from './paymentShared'

/**
 * `/payment/cancel` — Stripe Checkout's cancel return (legacy lib
 * `PaymentCancelComponent`): expires the session this tab started (once per
 * visit), forgets it, and offers the way back to the same-site page the
 * payment started from.
 */
export function PaymentCancelPage() {
  const started = useRef(false)
  const [returnPath, setReturnPath] = useState<string | null>(null)

  useEffect(() => {
    if (started.current) return
    started.current = true
    const sessionId = storedCheckoutSessionId()
    const back = storedReturnPath()
    const finish = () => {
      clearCheckoutState()
      setReturnPath(back)
    }
    if (!sessionId) {
      finish()
      return
    }
    paymentClient.expireSession(sessionId).then(finish, finish)
  }, [])

  return (
    <PaymentPage title="Payment">
      <section className="portal-card" aria-label="Payment canceled">
        {returnPath === null ? (
          <p className="portal-notice portal-notice--info" role="status">
            <strong>Canceling payment.</strong> Please don&apos;t close this window.
          </p>
        ) : (
          <>
            <p className="portal-notice portal-notice--info" role="status">
              The payment was canceled. Nothing was charged.
            </p>
            <p>
              <Link to={returnPath}>Continue</Link>
            </p>
          </>
        )}
      </section>
    </PaymentPage>
  )
}
